export const detailsList = [
    {
        id: 1,
        name: "Fabric",
        unit: "yrd",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 2,
        name: "Stitching",
        unit: "yrd",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 3,
        name: "Lining",
        unit: "yrd",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 4,
        name: "Rod",
        unit: "ft",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 5,
        name: "Bracket",
        unit: "pcs",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 12,
        name: "Knobs",
        unit: "pcs",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 6,
        name: "Fitting Charges",
        unit: "--",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 7,
        name: "Tussel",
        unit: "pair",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 8,
        name: "Belt",
        unit: "pair",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 9,
        name: "Belt Hook",
        unit: "pair",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 10,
        name: "Box Making",
        unit: "ft",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 13,
        name: "Railing",
        unit: "pcs",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 15,
        name: "Blind Fabric",
        unit: "pcs",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 16,
        name: "Wall Paper",
        unit: "roll",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 16,
        name: "Blind Stiching",
        unit: "sq/ft",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 16,
        name: "Vinyl",
        unit: "sq/ft",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
    {
        id: 15,
        name: "Completed",
        unit: "total",
        qty: "",
        perUnitValue: "",
        amount: "",
    },
]